import { R } from 'core/helpers'

const combineStrings = (list, seperator = ' ') => {
  if (!R.isArray(list)) throw Error('The list param is not an array.')
  const sanitizedList = R.filter(list, (item) => typeof item === 'string')
  return R.compact(sanitizedList).join(seperator).trim()
}

export default combineStrings
